import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-admin-register-government',
  templateUrl: './admin-register-government.component.html',
  styleUrls: ['./admin-register-government.component.scss'],
})
export class AdminRegisterGovernmentComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
